import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token if present
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("svc_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
